// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/email_engagement_by_providers_data" endpoint
 */
/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { analyticsDashboardAppGroupIdEmailEngagementByProvidersData } from "./constants";
import type { analyticsDashboardAppGroupIdEmailEngagementByProvidersDataResult } from "./types";

export const getAnalyticsDashboardAppGroupIdEmailEngagementByProvidersData = reactQueryFetcherAdapter(
  analyticsDashboardAppGroupIdEmailEngagementByProvidersData,
  (
    signal: AbortSignal,
    app_group_id: string,
    start_date: number,
    end_date: number,
    metric: string,
    provider?: string
  ): Promise<analyticsDashboardAppGroupIdEmailEngagementByProvidersDataResult> => {
    return fetch(
      `/analytics_dashboard/${app_group_id}/email_engagement_by_providers_data`,
      "GET",
      { start_date, end_date, metric, provider },
      { signal }
    );
  }
);
